/* global Turbo */
import { Controller } from '@hotwired/stimulus'
import { useMutation } from 'stimulus-use'
import { useEventListener } from '~/controllers/concerns/use_event_listener'

const maximumHistorySize = 100

export default class extends Controller {
  static targets = ['closeButton']
  static values = { status: String } // used only by the `wait_for_lightbox_initialization` system test helper (to let Capybara wait until the expected click behavior of the close button is available)

  #history = []

  connect() {
    useMutation(this, { attributeFilter: ['src', 'complete'] })
    useEventListener(this, { event: 'turbo:submit-end', listener: 'onSubmitEnd' })

    this.#appendToHistory(window.location.toString())
    this.statusValue = 'ready'
  }

  disconnect() {
    this.#history = []
  }

  close(e) {
    const destination = e.target.href
    const index = this.#history.findIndex(url => url === destination)

    if (index === -1) {
      if (e.type === 'click') {
        return // Falls back to normal link
      }
      return Turbo.visit(destination, { action: 'advance' })
    }

    e.preventDefault()
    return history.go(-1 * index)
  }

  /**
   * Filters set in `connect()` ensure we will only receive MutationRecord for
   * changes on managed turbo frame `src` attribute, so we don't need to check
   * entries.
   */
  mutate(_entries) {
    const url = this.element.getAttribute('src')
    this.#appendToHistory(url)
  }

  onSubmitEnd(e) {
    const { success } = e.detail

    // Nothing to do: forms should use `data-turbo-action="advance" so `src`
    // has already been updated (@see mutate)
    if (success) {
      return
    }

    // Otherwise, we must add a step in history to take count of the request.
    const url = this.element.getAttribute('src') || window.location.toString()
    this.#appendToHistory(url, true)
  }

  #appendToHistory(url, force) {
    if (this.#history[0] === url && !force) {
      return
    }

    this.#history.unshift(url)
    this.#history.splice(maximumHistorySize)
  }
}
